import React from "react";
import Footer from "../../layout/Footer";
import PrimaryButton from "../../shared/components/CustomButtons";
import StagesmartImg from "../../assets/images/stagesmartgpt.svg";
import GeneratedImg from "../../assets/images/generatedimg.png";
import GeneratedImg1 from "../../assets/images/generatedimg1.png";
import GeneratedImg2 from "../../assets/images/generatedimg2.png";
import GeneratedImg3 from "../../assets/images/generatedimg3.png";
import { Accordion, AccordionTab } from "primereact/accordion";
import FrequentQuestions from "./FrequentQuestions";

export default function StagesmartGPT() {
  const generatedImages = [
    GeneratedImg,
    GeneratedImg1,
    GeneratedImg2,
    GeneratedImg3,
  ];
  const faq = [
    {
      question: "Lorem Ipsum is simply dummy text?",
      answer:
        "Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible.",
    },
    {
      question: "What is the purpose of Lorem Ipsum?",
      answer:
        "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      question: "Where does Lorem Ipsum come from?",
      answer:
        "Contrary to popular belief, Lorem Ipsum is not simply random text.",
    },
    {
      question: "Is Lorem Ipsum safe to use?",
      answer:
        "Yes, it is completely safe. It is commonly used as placeholder text in design and development.",
    },
    {
      question: "Why do we use Lorem Ipsum?",
      answer:
        "It provides a distraction-free layout to test visual design without the need for real content.",
    },
  ];
  return (
    <>
      {/* banner start */}
      <div className="py-7">
        <div className="container">
          <div className="grid align-items-center">
            <div className="col-12 lg:col-5 p-4">
              <h2 className="heading text-4xl font-semibold">Stagesmart GPT</h2>
              <p className="text-gray-color line-height-2 font-normal line-height-3">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s
              </p>
              <p className="font-semibold sub-heading ">
                You can Buy 5 queries at just $10
              </p>
              <PrimaryButton
                label="Buy Now"
                extraClassNames="w-auto"
              // onClick={RedirectToService}
              />
            </div>
            <div className="col-12 lg:col-7">
              <img src={StagesmartImg} alt="" className="w-full" />
            </div>
          </div>
        </div>
      </div>
      {/* banner end */}
      <section className="bg-light-primary py-7">
        <div className="container">
          <h2 className="heading text-4xl font-semibold">
            What is Stagesmart GPT?
          </h2>
          <p className="text-gray-color line-height-2 font-normal line-height-3	">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to make a type specimen book. It has survived not
            only five centuries, but also the leap into electronic typesetting,
            remaining essentially unchanged. It was popularised in the 1960s
            with the release of Letraset sheets containing Lorem Ipsum passages,
            and more recently with desktop publishing software like Aldus
            PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply
            dummy text of the printing and typesetting industry. Lorem Ipsum has
            been the industry's standard dummy text ever since the 1500s, when
            an unknown printer took a galley of type and scrambled it to make a
            type specimen book. It has survived not only five centuries, but
            also the leap into electronic typesetting, remaining essentially
            unchanged. It was popularised in the 1960s with the release of
            Letraset sheets containing Lorem Ipsum passages, and more recently
            with desktop publishing software like Aldus PageMaker including
            versions of Lorem Ipsum.
          </p>
        </div>
      </section>
      {/* generated images start */}
      <section className="py-7">
        <div className="container">
          <h2 className="heading text-4xl font-semibold text-center">
            GPT Generated Images
          </h2>
          <p className="text-gray-color line-height-2 font-normal text-center line-height-3">
            Lorem Ipsum is simply dummy text of the printing and
            <br /> typesetting industry.
          </p>
          <div className="grid mt-5">
            {generatedImages.map((imgSrc, index) => (
              <div key={index} className="lg:col-6">
                <div className="generated-imgbox h-30rem">
                  <img
                    src={imgSrc}
                    alt={`Generated Image ${index + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* generated images end */}
      {/* faq start */}
      <FrequentQuestions />
      {/* <section className="py-7">
        <div className="container">
          <h2 className="heading text-center mt-0 text-4xl mb-4 rubik">
            Frequently asked questions
          </h2>
          <p className="text-gray-color text-center mb-7">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p>
          <Accordion
            className="w-full lg:w-8 m-auto faq-container"
            activeIndex={0}
            collapseIcon="pi pi-minus"
            expandIcon="pi pi-plus"
          >
            {faq?.map((item) => (
              <AccordionTab header={item?.question}>
                <p className="m-0 line-height-3">{item?.answer}</p>
              </AccordionTab>
            ))}
          </Accordion>
        </div>
      </section> */}
      {/* faq end */}
      {/* footer */}
      <Footer />
    </>
  );
}
